export default __webpack_public_path__ + "static/media/Mook Workshop.ed0a1a03.png";